import StepOne from "./StepOne";
import StepTwo from "./StepTwo";
import StepThree from "./StepThree";

export const Steps = [StepOne, StepTwo, StepThree];
